export default {
  'timeRange.today': '今天',
  'timeRange.yesterday': '昨天',
  'timeRange.thisWeek': '本周',
  'timeRange.lastWeek': '上周',
  'timeRange.thisMonth': '本月',
  'timeRange.lastMonth': '上月',
  'timeRange.last7D': '7天',
  'timeRange.last30D': '30天',
  'timeRange.7d': '7天',
  'timeRange.30d': '30天',
  'timeRange.last90D': '90天',
  'timeRange.3m': '3个月',
  'timeRange.12m': '12个月',
  'timeRange.custom': '自定义',
};
